module.exports = __webpack_public_path__ + "img/card-lucid.0e9e1845.png";